import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { TeamQueryParams, TEAM_NAME, SCREEN_SIZE, APP_URL } from 'types';
import { useSaga } from 'use-reducer-saga';
import reducer, { initialState } from './localStore/reducer';
import sagas from './localStore/sagas';
import { selectScreenSize, currentUser } from 'redux/session/selectors';
import { updateUserStart } from 'redux/session/actions';
import {
  resetCustomTeamBaseMap,
  setTeamBoundaryToggle
} from 'redux/team/actions';
import { getTeamsStart } from './localStore/actions';
import { useComponentMount } from 'utilities/hooks.util';
import { Switcher, SwitcherItem, Loading } from 'carbon-components-react';
import { ArrowLeft16 } from '@carbon/icons-react';

const TeamsPicker: React.FC<Props> = ({ onClose, onOpenpanel }) => {
  const screenSize = useSelector(selectScreenSize);
  const user = useSelector(currentUser);
  const dispatch = useDispatch();
  const location = useLocation();
  const [hidePrivate, setHidePrivate] = useState<boolean>(false);
  const [localStore, localDispatch] = useSaga(reducer, initialState, sagas);
  const { teams, loading } = localStore;

  const onSelectTeam = (id: number) => {
    dispatch(resetCustomTeamBaseMap()); //reset token
    dispatch(updateUserStart({ default_project: id > 0 ? id : null }));
    setTimeout(() => {
      dispatch(setTeamBoundaryToggle(true));
    }, 1000);
    onClose();
  };

  useEffect(() => {
    // hide private team option when
    // 1) is external user that not turn from trial
    // 2) is external user which turn from trial in create enquiry page.
    if (user) {
      if (user.is_as_external_user && !user.is_trial) {
        setHidePrivate(
          !user.trial_organisation_name?.trim() ||
            location.pathname === APP_URL.NEW_ENQUIRY
        );
      } else {
        setHidePrivate(false);
      }
    }
  }, [user, location]);

  useComponentMount(() => {
    const params: TeamQueryParams = {
      sorting: 'name,asc'
    };
    localDispatch(getTeamsStart(params));
  });

  return (
    <>
      {screenSize && screenSize === SCREEN_SIZE.SM && (
        <div className="panel-back bx--switcher__item">
          <div className="panel-back-btn" onClick={() => onOpenpanel('menu')}>
            <ArrowLeft16 />
          </div>
        </div>
      )}
      <div className="panel-title bx--switcher__item">
        <div className="bx--switcher__item-link no-clickable">
          Change team view
        </div>
      </div>
      <div className="team-picker-body">
        {!loading ? (
          <Switcher aria-label="Team picker">
            {!hidePrivate && (
              <SwitcherItem
                className="is-private"
                aria-label="Private team"
                onClick={() => onSelectTeam(0)}
              >
                {TEAM_NAME.PRIVATE}
              </SwitcherItem>
            )}
            {teams.map((team: any, inx: number) => (
              <SwitcherItem
                key={`team-${inx}`}
                aria-label={team.name}
                onClick={() => onSelectTeam(team.id)}
              >
                {team.name}
              </SwitcherItem>
            ))}
          </Switcher>
        ) : (
          <div className="team-picker-loading">
            <Loading withOverlay={false} />
          </div>
        )}
      </div>
    </>
  );
};

type Props = {
  onOpenpanel: Function;
  onClose: Function;
};

export default React.memo(TeamsPicker);
